import OurOfficeData from './dashboardFormat.json';
export const getUsersMetricesData = (string) => OurOfficeData[string];
export const getToolkitMetricsData = (string) => OurOfficeData[string];
export const getChartMetricsData = (string) => OurOfficeData[string];
export const getActionsMetricsData = (string) => OurOfficeData[string];
export const getStoriesMetricsData = (string) => OurOfficeData[string];